import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/dca.md?raw';

const TradingDCA: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingDCA;
